import { Component } from "@angular/core";
import { CommonModule } from "@angular/common";

@Component({
  selector: "app-ayuda",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./ayuda.component.html",
  styleUrl: "./ayuda.component.scss",
})
export class AyudaComponent {
  readonly telefono = "314 813 10 16";
  readonly telefonoLink = "tel:+573148131016";
  readonly email = "agenda@psicologa.co";
  readonly whatsapp = "+57 314 813 10 16";
  readonly whatsappLink =
    "https://api.whatsapp.com/send/?phone=573148131016&text=Hola%2C+quisiera+recibir+informaci%C3%B3n.&type=phone_number&app_absent=0";
}
